var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-tabs',{attrs:{"type":"card"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"模板管理"}},[_c('Template')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"字段管理"}},[_c('Filed')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }